import {useMediaQuery} from './useMediaQuery'

export enum Breakpoint {
  XS_ONLY = '(max-width: 703px)',
  SM_AND_UP = '(min-width: 704px)',
  SM_ONLY = '(min-width: 704px) and (max-width: 1024px)',
  SM_AND_DOWN = '(max-width: 1024px)',
  MD_AND_UP = '(min-width: 1025px)',
  MD_ONLY = '(min-width: 1025px) and (max-width: 1919px)',
  MD_AND_DOWN = '(max-width: 1919px)',
  LG_AND_UP = '(min-width: 1920px)',
  PRINT_ONLY = 'print',
  SCREEN_ONLY = 'screen',
}

export const useBreakpoint = (breakpoint: Breakpoint): boolean => {
  return useMediaQuery(breakpoint)
}
